<template>
  <v-dialog
    v-model="showDialog"
    width="800"
    @click:outside="closeDialog"
  >
    <v-card v-if="selectedMove && !selectedMove.device">
      <v-card-title>
        <span>{{ $t('move.actions.assignDeviceToMove') }}</span>
        <v-spacer/>
        <v-btn
          icon
          @click="closeDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text class="pt-5">
        <v-form ref="filterAssignDeviceForm">
          <v-row>
            <v-col md="6" xs="12" class="py-0">
              <v-text-field
                @input="updateFilterDebounce"
                v-model="filter.imei"
                :label="$t('device.fields.imei')"
                data-cy="imei"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text>
        <v-data-table
          :items="devices"
          :headers="headers"
          :options.sync="options"
          :server-items-length="devicesCount"
          :footer-props="{
            'items-per-page-text': $t('common.table.rowsPerPage'),
            'items-per-page-options': [5, 10, 15]
          }"
          must-sort
          data-cy="assignDeviceTable"
        >
          <template v-slot:item.type="{ item }">
            {{ $t(`device.type.${DEVICE_TYPE_ARR[item.type]}`) }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              small
              color="success"
              @click="assignDevice(item)"
              data-cy="assignDeviceBtn"
            >
              <v-icon small left color="white">
                mobile_friendly
              </v-icon>
              {{ $t('move.actions.assignDevice') }}
            </v-btn>
          </template>
          <template v-slot:no-data>
            {{ $t('common.noData') }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn
          color="primary"
          text
          @click="closeDialog"
        >
          {{ $t('common.form.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <confirmation-dialog-content
      v-else
      @onCancel="closeDialog"
      @onSubmit="triggerRemoveDeviceFromMove"
      :text="$t('move.actions.removeConfirmation', {
        moveName: this.selectedMove ? selectedMove.name : null,
        deviceName: this.selectedMove ? selectedMove.device.name : null
      })"
      :submitBtnTxt="$t('common.form.delete')"
      :cancelBtnTxt="$t('common.form.cancel')"
      data-cy="removeDeviceModal"
    />
  </v-dialog>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import * as actions from '@/store/actions.type';
  import {
    DEVICE_TYPE_ARR,
  } from '@/constants';
  import {
    NOTIFICATION_ERROR,
    NOTIFICATION_SUCCESS
  } from '@/common/event.types';
  import _ from 'lodash';
  import ConfirmationDialogContent from '@/components/dialogs/ConfirmationDialogContent';

  export default {
    name: 'AssignDeviceModal',
    data: () => ({
      DEVICE_TYPE_ARR,
      options: {},
      filter: {
        deviceStatusType: 0,
        imei: '',
      },
    }),
    props: {
      showDialog: Boolean,
      selectedMove: Object,
    },
    components: {
      ConfirmationDialogContent,
    },
    computed: {
      ...mapGetters([
        'devices',
        'devicesCount',
      ]),
      headers() {
        return [
          {
            text: this.$t('device.fields.name'),
            value: 'name',
            sortable: true,
            width: '25%',
          },
          {
            text: this.$t('device.fields.imei'),
            value: 'imei',
            sortable: true,
            width: '25%',
          },
          {
            text: this.$t('device.fields.deviceType'),
            value: 'type',
            sortable: true,
            width: '30%',
          },
          {
            text: this.$t('device.actions'),
            value: 'action',
            sortable: false,
            width: '20%',
          },
        ];
      },
    },
    watch: {
      options: {
        handler(options) {
          const newFilter = {...this.filter, ...options};
          this.updateFilterAction(newFilter);
        },
        deep: true,
      },
    },
    created() {
      this.updateFilterDebounce = _.debounce($event => {
        this.updateFilterAction(this.filter);
      }, 500);
    },
    mounted() {
      this.updateFilterAction(this.filter);
    },
    methods: {
      ...mapActions({
        updateFilterAction: actions.UPDATE_DEVICES_FILTER,
        assignDeviceToMoveAction: actions.ASSIGN_DEVICE_TO_MOVE,
        removeDeviceFromMoveAction: actions.REMOVE_DEVICE_FROM_MOVE,
      }),
      closeDialog() {
        this.$emit('dialog', false);

        if (!this.selectedMove.device) {
          this.$refs.filterAssignDeviceForm.reset();
        }
      },
      assignDevice(item) {
        this.assignDeviceToMoveAction({
          moveId: this.selectedMove.moveId,
          deviceId: item.id,
        }).then(() => {
          this.$eventHub.$emit(NOTIFICATION_SUCCESS, {
            message: this.$t('move.alerts.deviceAssignedToMoveSuccessful', {
              deviceName: item.name,
              moveName: this.selectedMove ? this.selectedMove.name : null,
            }),
          });
          this.closeDialog();
        }).catch(({data}) => {
          this.$eventHub.$emit(NOTIFICATION_ERROR, {
            message: data,
          });
        });
      },
      triggerRemoveDeviceFromMove() {
        this.removeDeviceFromMoveAction({
          moveId: this.selectedMove.moveId,
        }).then(() => {
          this.$eventHub.$emit(NOTIFICATION_SUCCESS, {
            message: this.$t('move.alerts.deviceRemovedFromMoveSuccessful', {
              deviceName: this.selectedMove ? this.selectedMove.device.name : null,
              moveName: this.selectedMove ? this.selectedMove.name : null,
            }),
          });
          this.closeDialog();
        }).catch(({data}) => {
          this.$eventHub.$emit(NOTIFICATION_ERROR, {
            message: data,
          });
        });
      },
    },
  };
</script>

<style scoped>

</style>
